import styled from 'styled-components';
import { media, colorUtils, colors, layout } from '@prisjakt/ui-base';
import { base100 } from '@prisjakt/design-tokens/light-theme-colors-raw';
import Button from '@prisjakt/ui-button';
import { Link as RouterLink } from 'react-router-dom';

const bannerBg = colorUtils.rgbaFromRaw(base100, { a: 0.95 });

export const Banner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 45px;
  background: ${bannerBg};
  z-index: 999;
`;

export const ContentsRow = styled.div`
  align-items: center;
`;

export const Logo = styled.img`
  flex: 0 0 auto;
  margin-left: ${layout.measurements.spacingNormal};
  ${media.smallOnly`
    display: none;
  `}
`;

export const Text = styled.div`
  flex: 1 1 auto;
  text-align: center;
  color: ${colors.lightTheme.base500};
  ${media.smallOnly`
    font-size: ${layout.measurements.fontSizeSmall};
  `}
  ${media.mediumUp`
    font-size: ${layout.measurements.fontSizeNormal};
  `}
`;

export const Link = styled(RouterLink)`
  color: ${colors.lightTheme.base500};
  text-decoration: underline;
`;

export const CloseButton = styled(Button)`
  width: 2.5rem;
  height: 2.5rem;
  border: none;
`;
